import styled from 'styled-components';
const transitionDuration = '200ms';
export const VolumeRocker = styled.div `
    display: inline-block;
    width: 20px;
    height: 68px;
    position: absolute;
    left: 30px;
    top: 40px;
`;
export const HoverArea = styled.div `
    display: inline-block;
    width: 80px;
    height: 125px;
    position: absolute;
    top: -125px;
    left: -28px;

    transition: opacity ${transitionDuration}, visibility ${transitionDuration},
        display ${transitionDuration};
    opacity: ${({ isVolumeOpened }) => (isVolumeOpened ? 1 : 0)};
    visibility: ${({ isVolumeOpened }) => (isVolumeOpened ? 'visible' : 'hidden')};
`;
//# sourceMappingURL=index.js.map